export const RequestTableCellName = {
  Assignees: 'assignees',
  Building: 'building',
  BuildingGroups: 'building_groups',
  BuildingObjectNumber: 'building_object_number',
  Category: 'category',
  ClosedAt: 'closed_at',
  ClosedBy: 'closed_by',
  CompletionTime: 'completion_time',
  Contractors: 'contractors',
  Created: 'created',
  CreatedBy: 'created_by',
  DueDate: 'due_date',
  Flat: 'flat',
  FlatEntranceAddress: 'flat_entrance_address',
  Owner: 'owner',
  Phases: 'phases',
  PrivateUpdated: 'private_updated',
  RequestNo: 'request_no',
  Status: 'status',
  ThreadEmailsCount: 'thread_emails_count',
  Title: 'title',
  Updated: 'updated',
  UpdatedBy: 'updated_by',
  VisibleToDwellers: 'visible_to_dwellers',
  Workers: 'workers',
}
